module.exports = __webpack_public_path__ + "static/media/uoa.67c07e64.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/UOAModal/uoa.png
// module id = 983
// module chunks = 0